import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

function Root() {
  useEffect(() => {
    // Remove splash screen after first paint
    requestAnimationFrame(() => {
      if (window.__removeSplash) window.__removeSplash();
    });
  }, []);
  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<Root />);
